import { tap } from 'rxjs';
import { PageConfigInterface } from '@/app/features/page-config';

import { signal, Injectable, WritableSignal } from '@angular/core';

import { PageConfigService } from '@/app/core/services/page-config/page-config.service';

@Injectable({
  providedIn: 'root',
})
export class PageConfigStore {
  public pageConfig: WritableSignal<PageConfigInterface | undefined> = signal(undefined);

  constructor(private apiService: PageConfigService) {}

  public loadPageConfig(userId?: number, loadAsAdmin: boolean = false) {
    return this.apiService.getPageConfig(userId, loadAsAdmin).pipe(
      tap((response) => {
        this.pageConfig.set(response.payload.content);
      }),
    );
  }

  public updatePageConfig(body: any, userId?: number, loadAsAdmin: boolean = false) {
    return this.apiService.updatePageConfig(body, userId, loadAsAdmin).pipe(
      tap((response) => {
        this.pageConfig.set(response.payload.content);
      }),
    );
  }
}
